export const DefaultRedWarnStyle = "material";
